import { render } from "./CustomTakePhotoCamera.vue?vue&type=template&id=3d13478a&scoped=true"
import script from "./CustomTakePhotoCamera.vue?vue&type=script&lang=ts"
export * from "./CustomTakePhotoCamera.vue?vue&type=script&lang=ts"

import "./CustomTakePhotoCamera.vue?vue&type=style&index=0&id=3d13478a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d13478a"

export default script